module.exports = __webpack_public_path__ + "static/media/bronze-ticket-transparent.4e642106.png";